import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { PageHeader } from '../../components/common';
import { DomainList } from '../../features/domains/components';
import { ROUTES } from '../../config/routes';
import { usePageTitle } from '../../hooks/usePageTitle';
import { Button } from '../../components/ui/button';

export const DomainsListPage: React.FC = () => {
  usePageTitle('チャットBOT');
  const navigate = useNavigate();

  return (
    <div>
      <PageHeader
        title="チャットBOT"
        action={
          <Button onClick={() => navigate(ROUTES.DOMAIN_NEW)}>
            <Plus className="h-4 w-4 mr-2" />
            チャットBOTを作成
          </Button>
        }
      />
      <DomainList />
    </div>
  );
};
